export default __webpack_public_path__ + "static/media/article-react.50f208d4.png";